import { LearningFeature } from 'src/api/learningQueue/types';
import { Lesson, RecommendedLesson } from 'src/apps/MyLessons/types';

export const getLearningFeaturesKey = (learningFeatures: LearningFeature[]) => {
  if (learningFeatures.length === 0) return null;

  return learningFeatures.map(l => `${l.type}_${l.skippable}`).join(';');
};

export const getLessonsKey = (
  recommendedLesson: RecommendedLesson | null,
  upcomingLessons: Lesson[],
) => {
  if (!recommendedLesson) return null;

  return getLearningFeaturesKey([recommendedLesson, ...upcomingLessons]);
};
